import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

import { reactive } from 'vue';
import { useRoute } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'PaymentView',
  setup(__props) {

const route = useRoute();

const props = reactive({
    payment_token: route.params.token,
});

const state = reactive({
    payment_url: process.env.VUE_APP_SWP_URL + '/payment/' + props.payment_token
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("iframe", {
    width: "100%",
    height: "600px",
    src: state.payment_url
  }, null, 8, _hoisted_1))
}
}

})